import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '@core/guards/auth.guard';
import { AdminAuthGuard } from '@core/guards/admin-auth.guard';
import { IsTeacherGuard } from '@core/guards/is-teacher.guard';
import { NotFoundComponent } from './not-found/not-found.component';
import { RedirectComponent } from './redirect/redirect.component';
import { RedirectRouteGuard } from '@core/guards/redirect-route.guard';
import { ROUTES } from '@utils/constants';
import { StudentHasAcceptedAgreementsGuard } from '@core/guards/student-has-accepted-agreements.guard';
import { TeacherHasAcceptedAgreementGuard } from '@core/guards/teacher-has-accepted-agreement.guard';
import { LoggedInCheckGuard } from './infrastructure/core/guards/logged-in.guard';

const routes: Routes = [
  {
    path: '',
    component: RedirectComponent,
    canActivate: [RedirectRouteGuard],
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./features/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: ROUTES.admin.root,
    canActivate: [AdminAuthGuard],
    canActivateChild: [AdminAuthGuard, LoggedInCheckGuard],
    loadChildren: () =>
      import('./features/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: ROUTES.auth.root,
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: ROUTES.student.root,
    canActivate: [AuthGuard, StudentHasAcceptedAgreementsGuard],
    canActivateChild: [
      AuthGuard,
      StudentHasAcceptedAgreementsGuard,
      LoggedInCheckGuard,
    ],
    loadChildren: () =>
      import('./features/student/student.module').then((m) => m.StudentModule),
  },
  {
    path: ROUTES.teacher.root,
    canActivate: [AuthGuard, TeacherHasAcceptedAgreementGuard, IsTeacherGuard],
    canActivateChild: [
      AuthGuard,
      TeacherHasAcceptedAgreementGuard,
      IsTeacherGuard,
      LoggedInCheckGuard,
    ],
    loadChildren: () =>
      import('./features/teacher/teacher.module').then((m) => m.TeacherModule),
  },
  {
    path: ROUTES.user.root,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard, LoggedInCheckGuard],
    loadChildren: () =>
      import('./features/user/user.module').then((m) => m.UserModule),
  },
  {
    path: ROUTES.app.notFound.path,
    component: NotFoundComponent,
    data: { title: ROUTES.app.notFound.title },
  },
];

/**
 * Root feature routing module. Loads all lazy loaded routes and root-level routes.
 */
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}

export const components = [NotFoundComponent, RedirectComponent];
